import React from "react";

export default function MessageInfo(props) {

  return (
    <div className="message-info">
      {props.component}
      <h2 className="mt-10">{props.title}</h2>
      <p>{props.subtitle}</p>
      {props.children}
    </div>
  );
}